import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET } from "../../services/axios.service";
import { RootState } from "../../app/store";
import {
  MaterialDateBy,
  MaterialSortBy,
  MaterialSortOrder,
  MaterialsProps,
} from "../../types/material";

export interface MaterialsState {
  materials: MaterialsProps[];
  totalMaterials: number;
  isMaterialModalOpen: boolean;
  editMaterial: MaterialsProps | null;
  loading: boolean;
  error: string | null;
}

const initialState: MaterialsState = {
  materials: [],
  totalMaterials: 0,
  isMaterialModalOpen: false,
  editMaterial: null,
  loading: false,
  error: null,
};

type FetchMaterialsListDataProps = {
  page: number;
  size?: number;
  fromDate?: string | null;
  toDate?: string | null;
  search?: string | null;
  date_by?: MaterialDateBy;
  sort_by?: MaterialSortBy;
  sort_order?: MaterialSortOrder;
  // Each size's bars in stock (only for a user who may see the stock).
  with_stock?: 1;
};

export const fetchMaterialsListData = createAsyncThunk(
  "fetchMaterialsListData",
  async (req: FetchMaterialsListDataProps) => {
    let response: any;
    await GET(`/v1/admin/materials`, { ...req })
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const materialsSlice = createSlice({
  name: "materials",
  initialState,
  reducers: {
    toggleMaterialModal: (state, action: PayloadAction<boolean>) => {
      state.isMaterialModalOpen = action.payload;
    },
    setEditMaterial: (state, action: PayloadAction<MaterialsProps | null>) => {
      state.editMaterial = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchMaterialsListData.pending, (state, action: any) => {
      state.materials = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchMaterialsListData.fulfilled, (state, action: any) => {
      state.loading = false;
      if (action.payload.data.status === "success") {
        state.materials = action.payload.data.data.records;
        state.totalMaterials = action.payload.data.data.total_records;
        state.error = null;
      } else {
        state.materials = [];
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    });
    builder.addCase(fetchMaterialsListData.rejected, (state, action: any) => {
      state.materials = [];
      state.loading = false;
      state.error =
        action?.payload?.data?.message ||
        "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
    });
  },
});

export const { toggleMaterialModal, setEditMaterial } = materialsSlice.actions;

export const getMaterials = (state: RootState) => state.materials.materials;

export const getTotalMaterials = (state: RootState) =>
  state.materials.totalMaterials;

export const getIsMaterialModalOpen = (state: RootState) =>
  state.materials.isMaterialModalOpen;

export const getEditMaterial = (state: RootState) =>
  state.materials.editMaterial;

export default materialsSlice.reducer;
